<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16lPxRR/d2d_images/cover.jpg?1720280630595" alt="This image is the cover for the book Da Zero a Sexy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Da Zero a Sexy
      </h1>
      <p class="bookDescription body article font2">
        <p>Dal momento che Santana si nasconde da qualcosa di brutto appartenente al suo passato, vive giorno per giorno e non osa sognare un futuro. La sua vita si svolge solo all’interno del sensuale mondo di Kidnap Fantasies, una società di escort top-secret in cui esplora la propria sessualità e gode del piacere sia con uomini che con donne.<br/> Ma è amore a prima vista nel momento in cui vede Amy al matrimonio di un suo caro amico. La ragazza sa di futuro ma lui è consapevole che quello è un desiderio che deve negarsi; quindi, perché le sussurra<i>sei mia</i>?<br/> Nell’istante in cui Amy Sparks vede il bell’afroamericano al matrimonio di sua sorella, sa in cuor suo che lui è tutto ciò che ha sempre sognato in un amante, ma prima che possano conoscersi meglio, lui scompare misteriosamente.<br/> Dopo aver scoperto che lavora per la Kidnap Fantasies, Amy saprà come lui riuscirà ad avverare tutte le sue intime fantasie...<br/> E quando Santana scoprirà che la sua prossima cliente della Kidnap Fantasies è Amy, saprà anche di doverla proteggere dal suo passato consapevole che quell’esperienza intima tra loro non potrà ripetersi...<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jan Springer, Arianna Giorgi
      </h2>
      
      <p class="authorDescription body article">Jan Springer vive a Minden Hills, Ontario, Canada. Scrive a tempo pieno e le piace andare in kayak, è appassionata di fotografia, escursionismo, lettura e scrittura. E' un membro del Romance Writers of America e del Writers's Union of Canada.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Spunky Girl Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70e3545d